export default "/fonts/vendor/remixicon/remixicon.symbol.svg?5540ed538fb6bd400d2a6ddc22bc5671";